import React from 'react';
import { useLocation } from 'react-router-dom';
import Navbar from '../Navbar';
import Sidebar from './Sidebar';
import Footer from '../Footer';
import { EstimationFormProvider } from '../../contexts/EstimationFormContext';

// Routes where the layout footer should not be displayed
// (pages that have their own fixed bottom bar)
const NO_FOOTER_ROUTES = ['/estimation/assistant'];

interface AuthenticatedLayoutProps {
  children: React.ReactNode;
}

const AuthenticatedLayout: React.FC<AuthenticatedLayoutProps> = ({ children }) => {
  const location = useLocation();
  const showFooter = !NO_FOOTER_ROUTES.includes(location.pathname);

  return (
    <EstimationFormProvider>
      <div className="flex flex-col h-screen overflow-hidden" style={{ background: 'var(--color-surface)' }}>
        <Navbar />
        <div className="flex flex-1 min-h-0 overflow-hidden">
          <Sidebar />
          <main className="flex-1 min-h-0 overflow-y-auto flex flex-col">
            <div style={{ flex: 1 }}>
              {children}
            </div>
            {showFooter && <Footer />}
          </main>
        </div>
      </div>
    </EstimationFormProvider>
  );
};

export default AuthenticatedLayout;
